import React, {useEffect, useState} from 'react';
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import projectUtils from "../../../../utils/project-utils.js";
import streetService from "../../../../services/web/street-service.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import { FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const StreetForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({name: ""})

    const { status, refetch: refetchStreet} = useQuery({
        queryFn: () =>  streetService.get(id).then((data) => {
            setState(data)
            return []
        }),
        queryKey: ['street'],
        enabled: !!id
    });

    useEffect(() => {
        if (id) {
            if (status === 'success') setIsLoading(false)
            else setIsLoading(true)
        }
    }, [status]);

    const onChange = ({target: {value, id}}) => setState(prev => ({...prev, [id]: value}))

    const save = () => {
        const formData = new FormData();

        const form = {
            name: state.name
        };

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        if (!!id) formData.append('_method', 'PUT');


        const response = !!id ? streetService.edit(id, formData) : streetService.create(formData);
        response
            .then(({data}) => {
                projectUtils.success(!id);

                if (id) {
                    refetchStreet();
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = message ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })

    }

    const destroy = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir o logradouro "${state.name ?? ""}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    streetService.destroy(id).then(() => {
                        navigateToList()
                        projectUtils.success(true, "Excluído com sucesso");
                    })
                }
            }
        );
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/street`;
        navigate(urlDev, isBlank);
    }

    const newStreet = () => {
        let isBlank = false;
        let urlDev = `/street/form`;
        navigate(urlDev, isBlank);
    }

    const navigateToEdit = (data) => {
        let isBlank = false;
        let urlDev = `/street/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Logradouro
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={() => newStreet()}>
                            <FaPlus/>
                            Adicionar logradouro
                        </Button>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12">
                                <InputForm id="name" value={state.name} onChange={onChange}
                                           label="Nome *"/>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    id &&
                                    <>
                                        <Button target="danger" onClick={destroy} actionFeedbackType="delete">
                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType="save">
                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default StreetForm;